<template>
    <div class="policies">
      <div class="page__header">
        <div class="page__title">{{ $t('policies.title') }}</div>
        <div class="page__right">
          <div class="selected-filters" v-if="selectedTeams.length > 0 || (searchPoliciesForms && Object.keys(searchPoliciesForms).length > 0)">
              
            <div class="selected-filters__filter" v-for="teamId in selectedTeams" :key="`team${teamId}`">
              <span>
                Team: {{
                  (loggedUser.teams && loggedUser.teams.find(t => t.id == teamId))
                    ? loggedUser.teams.find(t => t.id == teamId).name
                    : 'Team ' + teamId
                }}
              </span>
              <div class="selected-filters__remove" @click="removeTeam(teamId)"></div>
            </div>

            <div class="selected-filters__filter" v-if="startDateFrom || startDateTo">
              <span>{{ $t('searchCustomerFields.policyStartDate') }}: {{ formatDateShort(startDateFrom) || '...' }} - {{ formatDateShort(startDateTo) || '...' }}</span>
              <div class="selected-filters__remove" @click="clearStartDateRange()"></div>
            </div>

            <div class="selected-filters__filter" v-if="endDateFrom || endDateTo">
              <span>{{ $t('searchCustomerFields.policyEndDate') }}: {{ formatDateShort(endDateFrom) || '...' }} - {{ formatDateShort(endDateTo) || '...' }}</span>
              <div class="selected-filters__remove" @click="clearEndDateRange()"></div>
            </div>

            <div class="selected-filters__filter" v-if="submitDateFrom || submitDateTo">
              <span>{{ $t('searchCustomerFields.policySubmitDate') }}: {{ formatDateShort(submitDateFrom) || '...' }} - {{ formatDateShort(submitDateTo)  || '...' }}</span>
              <div class="selected-filters__remove" @click="clearSubmitDateRange()"></div>
            </div>

            <div class="selected-filters__filter" v-for="agentId in selectedAgents" :key="`agent${agentId}`">
              <span>
                {{
                  (searchPoliciesForms.agents && searchPoliciesForms.agents.find(a => a.id == agentId))
                    ? searchPoliciesForms.agents.find(a => a.id == agentId).first_name + ' ' +
                    searchPoliciesForms.agents.find(a => a.id == agentId).last_name
                    : 'Agent ' + agentId
                }}
              </span>
              <div class="selected-filters__remove" @click="removeAgent(agentId)"></div>
            </div>
     
            <div class="selected-filters__filter" v-for="companyId in selectedCompanies" :key="`company${companyId}`">
              {{
                searchPoliciesForms.companies?.find(
                  (item) => item.id === companyId
                )?.name
              }}
              <div class="selected-filters__remove" @click="removeCompany(companyId)"></div>
            </div>

            <div class="selected-filters__filter" v-for="statusId in selectedPolicyStatuses" :key="`status${statusId}`">
              <span>{{
                searchPoliciesForms.policyStatuses?.find(
                  (item) => item.id === statusId
                )?.[`long_${language}`]
              }}</span>
              <div class="selected-filters__remove" @click="removePolicyStatus(statusId)"></div>
            </div> 
          </div>

          <form class="search search--filter" @submit.prevent="keywordsSearch()">
            <div class="search__wrapper">
              <input
                class="search__search"
                ref="search"
                :class="{ 'search__search--active': searchKeywords }"
                type="text"
                v-model="searchKeywords"
              />
              <div class="search__icon"></div> 
              <div class="search__splitter"></div>
            </div>
            <div
              class="search__filter"
              ref="filterToggler"
              @click="showSearchFilter = !showSearchFilter"
            ></div>
            <SearchFilter
              v-if="showSearchFilter"
              :searchType="'policy'"
              :filterToggler="filterToggler"
              :toggleSearchFilter="
                (state) => {
                  showSearchFilter = state;
                }
              "
            />
          </form> 
        </div>
      </div>
      
      <div class="customers__content" >
        <Loading v-if="policiesLoading" /> 
        <div v-else>
          <NoData style="height: 80vh;" :type="'policiesList'" v-if="!policiesPerPage.data || policiesPerPage.data.length == 0"/>
          <div v-else class="table">
            <div class="table__header box box--default">
              <div class="table__label table__label--small" style="padding-right: 0 !important;"></div>
              <div class="table__label table__label--large"> 
                {{ $t('policies.tableHead.insurance') }} 
              </div>

              <div class="table__label table__label--medium"> 
                {{ $t('policies.tableHead.plateNr') }}   
              </div>

              <div class="table__label table__label--large">
                {{ $t('policies.tableHead.company') }} 
              </div>
              <div class="table__label table__label--small">
                {{ $t('policies.tableHead.status') }} 
              </div>
              <div class="table__label table__label--large">
                {{ $t('policies.tableHead.customer') }} 
              </div>
              <div class="table__label table__label--medium">
                {{ $t('policies.tableHead.policyNr') }} 
              </div>
              <div class="table__label table__label--medium">
                {{ $t('policies.tableHead.created') }} 
              </div>
              <div class="table__label table__label--large">
                {{ $t('policies.tableHead.agent') }}  
              </div>
              <div class="table__label table__label--small" style="padding: 0 !important;"> 
              </div> 
              <div class="table__label table__label--small" style="padding: 0 !important;"> 
              </div>
              
            </div>

          <div class="table__body">
            <div class="row policy-row row--hover box box--default" v-for="policy in policiesPerPage.data"
              :key="policy.id" :class="[policy.policy_status ? `policy--${policy.policy_status.long_en}` : '']"
              @click="goToCustomer(policy.customer, policy.customer_id, policy.id)">
              <div class="row__data row__data--small policy-icon" style="padding-right: 0 !important;"> 
                <div :class="[
                  'icon',
                  `icon__policy--${policy.policy_services.find(s => s.service && s.service.id === selectedPolicies[policy.id])
                    ? policy.policy_services.find(s => s.service && s.service.id === selectedPolicies[policy.id]).service.branch_category.id
                    : 'krankenkasse'
                  }`
                ]">
                </div>
              </div>

              <div class="row__data row__data--large">
                <div v-if="policy.policy_services && policy.policy_services.length > 0"
                  style="width: 100%;  text-align: center;">
                  <VSelect @click.stop v-if="policy.policy_services.length > 1" style="width: 100%; background: 0;"
                    :options="policy.policy_services.filter(s => s.service && s.service.branch_category).map(s => ({
                      label: s.service.branch_category.name,
                      value: s.service.id
                    }))" label="label" :reduce="option => option.value"
                    class="select select--default customer__dropdown" v-model="selectedPolicies[policy.id]" />

                  <span v-else>
                    {{ policy.policy_services[0].service && policy.policy_services[0].service.branch_category ?
                      policy.policy_services[0].service.branch_category.name : '------' }}
                  </span>

                </div>
                <span v-else>------</span>
              </div>

              <div class="row__data row__data--name row__data--medium">
                <span v-if="policy.plate_number">{{ policy.plate_number }} </span>
                <span v-else>------</span>
              </div>


              <div class="row__data row__data--name row__data--large">
                <div v-if="policy.company">
                  <p>{{ policy.company.full_name }}</p>
                </div>
                <div v-else>------</div>
              </div>
              <div class="row__data row__data--small">
                <div v-if="policy.policy_status">
                  <p>{{ policy.policy_status.name }}</p>
                </div>
                <div v-else>------</div>
              </div>
              <div class="row__data row__data--name row__data--large">
                <div v-if="policy.customer">
                  <span v-if="policy.customer.company_name">
                    {{ policy.customer.company_name }}
                  </span>
                  <span v-else>
                    {{ policy.customer.first_name }} {{ policy.customer.last_name }}
                  </span>
                </div>
                <div v-else>------</div>
              </div>
              <div class="row__data row__data--medium">
                <div v-if="policy.policy_number">
                  <p>{{ policy.policy_number }}</p>
                </div>
                <div v-else>------</div>
              </div>
              <div class="row__data row__data--medium">
                <div>
                  <p>{{ formatDate(policy.created_at) }}</p>
                </div>
              </div>
                <div  class="row__data row__data--name row__data--large" >
                  <div v-if="policy.agent">
                    {{policy.agent.first_name}} {{policy.agent.last_name}}
                  </div>
                  <div v-else>------</div> 
                </div> 
                <div class="row__data row__data--small row__data--pdf" @click.stop style="padding: 0 !important;">
                  <div @click="openPolicyFilesModal(policy.id, policy.policy_files, policy.customer_id)" class="icon icon__pdf" :class="{ 'icon__pdf--active': policy.policy_files && policy.policy_files.length }"></div>
                </div>
                <div class="row__data row__data--action row__data--small" style="padding: 0 !important;"></div>   
              </div>
            </div>

          <Pagination :limit="3" :data="policiesPerPage" @pagination-change-page="getResults"></Pagination>
        </div>
      </div>
    </div>
  </div>
</template>

  <script setup>
  import { ref, computed, watch, onMounted, getCurrentInstance } from "vue";
  import { useStore } from "vuex";
  import { useRoute, useRouter } from "vue-router";
  import SearchFilter from "@/partials/SearchFilter";
  import Loading from "@/partials/Loading";
  import NoData from "@/partials/NoData";

  const store = useStore();
  const route = useRoute();
  const router = useRouter();
  const instance = getCurrentInstance();

  // Template refs
  const search = ref(null);
  const filterToggler = ref(null);

  // Reactive data
  const searchKeywords = ref("");
  const showSearchFilter = ref(false);
  const selectedTeams = ref([]);
  const selectedAgents = ref([]);
  const selectedCompanies = ref([]);
  const selectedBranchCategories = ref([]);
  const selectedPolicyStatuses = ref([]);
  const selectedPolicies = ref({});
  const startDateFrom = ref("");
  const startDateTo = ref("");
  const endDateFrom = ref("");
  const endDateTo = ref("");
  const submitDateFrom = ref("");
  const submitDateTo = ref("");
  const initialLoadDone = ref(false);

  // Computed properties
  const policiesPerPage = computed(() => store.getters.policiesPerPage);
  const policiesLoading = computed(() => store.getters.policiesLoading);
  const searchPoliciesForms = computed(() => store.getters.searchPoliciesForms);
  const loggedUser = computed(() => store.getters.loggedUser);
  const language = computed(() => store.getters.language);
  const showPolicyFilesModal = computed(() => store.getters.showPolicyFilesModal);

  // Watchers
  watch(
    () => showPolicyFilesModal.value,
    (newVal) => {
      // When modal closes (newVal becomes false), refresh the table
      if (!newVal) {
        searchPolicies();
      }
    }
  );

  // Methods
  const searchPolicies = async () => {
    store.commit("setPoliciesLoading", true);
  
    const q = route.query;
    const page = Number(q.page) || 1;
     
    const teams = q.teams ? q.teams.split(",").map(Number) : [];
    const agents = q.agents ? q.agents.split(",").map(Number) : [];
    const companies = q.companies ? q.companies.split(",").map(Number) : [];
    const policyStatuses = q.policyStatuses ? q.policyStatuses.split(",").map(Number) : [];
    const branchCategories = q.branchCategories ? q.branchCategories.split(",").map(Number) : [];

    try {
      await store.dispatch("searchPolicies", {
        page,
        teams,
        agents,
        companies,
        branchCategories,
        policyStatuses,
        search: q.search || "",
        startDateFrom: q.startDateFrom || "",
        startDateTo: q.startDateTo || "",
        endDateFrom: q.endDateFrom || "",
        endDateTo: q.endDateTo || "",
        submitDateFrom: q.submitDateFrom || "",
        submitDateTo: q.submitDateTo || "",
      });
    } finally {
      store.commit("setPoliciesLoading", false);
    }
  };

  const loadFiltersFromQuery = async (q) => {
    searchKeywords.value = q.search || "";
    selectedTeams.value = q.teams ? q.teams.split(",").map(Number) : [];
    selectedAgents.value = q.agents ? q.agents.split(",").map(Number) : [];
    selectedCompanies.value = q.companies ? q.companies.split(",").map(Number) : [];
    selectedBranchCategories.value = q.branchCategories ? q.branchCategories.split(",").map(Number) : [];
    selectedPolicyStatuses.value = q.policyStatuses ? q.policyStatuses.split(",").map(Number) : [];
    startDateFrom.value = q.startDateFrom || "";
    startDateTo.value = q.startDateTo || "";
    endDateFrom.value = q.endDateFrom || "";
    endDateTo.value = q.endDateTo || "";
    submitDateFrom.value = q.submitDateFrom || "";
    submitDateTo.value = q.submitDateTo || "";
  };

  const removePolicyStatus = (id) => {
    selectedPolicyStatuses.value = selectedPolicyStatuses.value.filter((x) => x !== id);
    updateQuery();
  };

  const removeAgent = (id) => {
    selectedAgents.value = selectedAgents.value.filter((x) => x !== id);
    updateQuery();
  };

  const removeCompany = (id) => {
    selectedCompanies.value = selectedCompanies.value.filter((x) => x !== id);
    updateQuery();
  };

  const clearStartDateRange = () => {
    startDateFrom.value = "";
    startDateTo.value = "";
    updateQuery();
  };

  const clearEndDateRange = () => {
    endDateFrom.value = "";
    endDateTo.value = "";
    updateQuery();
  };

  const clearSubmitDateRange = () => {
    submitDateFrom.value = "";
    submitDateTo.value = "";
    updateQuery();
  };

  const removeTeam = (id) => {
    selectedTeams.value = selectedTeams.value.filter((x) => x !== id);

    if (selectedTeams.value.length === 0) {
      clearAllDependentFilters();
    }

    updateQuery();
  };

  const clearAllDependentFilters = () => {
    selectedAgents.value = [];
    selectedCompanies.value = [];
    selectedBranchCategories.value = [];
    selectedPolicyStatuses.value = [];
    startDateFrom.value = "";
    startDateTo.value = "";
    endDateFrom.value = "";
    endDateTo.value = "";
    submitDateFrom.value = "";
    submitDateTo.value = "";

    store.commit("setSearchPoliciesForms", {});
  };

  const goToCustomer = (customer, customerId, policyId) => {
    if (customer && customer.id) {
      router.push(`/account-details/customer/${customer.id}/policy/${policyId}`);
    } else {
      router.push(`/account-details/customer/${customerId}/policy/${policyId}`);
    }
  };

  const openPolicyFilesModal = (id, files, customerId) => {
    store.commit("setPolicyFileId", id);
    store.commit("setPolicyFiles", files);
    store.commit("setCustomerFromDashboard", customerId);
    store.commit("setFilesFromDashboard", true);
    store.commit("setShowPolicyFilesModal", true);
  };

  const formatDate = (date) => {
    if (!date) return '';
    const d = new Date(date);
    const day = String(d.getDate()).padStart(2, '0');
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const year = d.getFullYear();
    return `${day}.${month}.${year}`;
  };

  const formatDateShort = (dateString) => {
    if (!dateString) return null;
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return dateString;

    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = String(date.getFullYear()).slice(-2);

    return `${day}/${month}/${year}`;
  };

  const updateQuery = () => {
    const query = {
      page: 1,
      search: searchKeywords.value || undefined,
      teams: selectedTeams.value.length ? selectedTeams.value.join(",") : undefined,
      agents: selectedAgents.value.length ? selectedAgents.value.join(",") : undefined,
      companies: selectedCompanies.value.length ? selectedCompanies.value.join(",") : undefined,
      branchCategories: selectedBranchCategories.value.length ? selectedBranchCategories.value.join(",") : undefined,
      policyStatuses: selectedPolicyStatuses.value.length ? selectedPolicyStatuses.value.join(",") : undefined,
      startDateFrom: startDateFrom.value || undefined,
      startDateTo: startDateTo.value || undefined,
      endDateFrom: endDateFrom.value || undefined,
      endDateTo: endDateTo.value || undefined,
      submitDateFrom: submitDateFrom.value || undefined,
      submitDateTo: submitDateTo.value || undefined,
    };

    router.replace({ query }).catch(() => {});
  };

  const getResults = async (paginationPage) => {
    router.replace({
      query: { ...route.query, page: paginationPage },
    });
  };

  const keywordsSearch = async () => {
    updateQuery();
  };

  // Watchers
  watch(
    () => policiesPerPage.value?.data,
    (newPolicies) => {
      if (!newPolicies || !Array.isArray(newPolicies)) return;

      newPolicies.forEach(policy => {
        if (!selectedPolicies.value[policy.id] && policy.policy_services && policy.policy_services.length > 0) {
          selectedPolicies.value[policy.id] = policy.policy_services[0].service.id;
        }
      });
    },
    { deep: true, immediate: true }
  );

  watch(
    () => route.query,
    async (query, oldQuery) => {
      if (!query.page) {
        router.replace({
          query: { ...query, page: 1 },
        }).catch(() => {});
        return;
      }

      if (oldQuery && JSON.stringify(query) === JSON.stringify(oldQuery)) {
        return;
      }

      loadFiltersFromQuery(query);

      await searchPolicies();
       
      initialLoadDone.value = true;
    },
    { immediate: true, deep: true }
  );

  // Lifecycle
  onMounted(async () => {
    if (!(instance.proxy.$checkRolePermission('customer_access') || instance.proxy.$checkRolePermission('customer_show'))) {
      router.push('/dashboard');
      return;
    }

    try {
      const teams = route.query.teams ?
        route.query.teams.split(",").map(Number) :
        (loggedUser.value.teams?.length === 1 ? [loggedUser.value.teams[0].id] : []);
      
      if (teams.length > 0) {
        await store.dispatch("getSearchPoliciesForms", teams);
      }
    } catch (e) {
      console.error("Form Load Error", e);
    }
  });
  </script>


<style lang="scss" scoped>
.policy-row {
  position: relative;

  &::before {
    position: absolute;
    z-index: 3;
    content: "";
    left: 0;
    top: -1px;
    height: calc(100% + 2px);
    width: 15px;
    border-top-left-radius: var(--radius-1);
    border-bottom-left-radius: var(--radius-1);
  }
}

.policy--Active {
  &::before {
    background-color: #22DB8E;
  }
}

.policy--Submitted,
.policy--Processing {
  &::before {
    background-color: #FF9E0F;
  }
}

.policy--Inactive {
  &::before {
    background-color: #DB2222;
  }
}

</style>
